import { Module } from 'vuex';

import { Optional, RootState } from 'frontend/types';
import { GiftPurchaseApiInputs, GiftPurchaseSuccessState } from 'frontend/types/premium/gifts';
import { getJson } from 'frontend/utils/ajax';

const INITIAL_STATE: GiftPurchaseSuccessState = {
  gifter_email: undefined,
  giftee_email: undefined,
  delivery_date_is_future: undefined,
  delivery_date_formatted: undefined,
  subscribed_to_extra_emails: undefined,
  signed_up_today: undefined,
};

const giftPurchaseSuccess: Module<GiftPurchaseSuccessState, RootState> = {
  namespaced: true,
  state: INITIAL_STATE,
  mutations: {
    setValue(state: GiftPurchaseSuccessState, value: GiftPurchaseSuccessState) {
      Object.assign(state, value);
    },
    toggleSubscriptionStatus(state: GiftPurchaseSuccessState) {
      state.subscribed_to_extra_emails = !state.subscribed_to_extra_emails;
    },
  },
  actions: {
    async getPurchase(
      { commit },
      { router, giftMessageId }: GiftPurchaseApiInputs,
    ): Promise<boolean> {
      const url = router.resolve({
        name: 'gift_purchase_success',
        query: {
          gift_message_id: giftMessageId.toString(),
        },
      }).href;
      const response = await getJson(url);
      const data = response.results.gift_purchase_success;
      if (data) {
        commit('setValue', data);
        return true;
      }
      return false;
    },
  },
  getters: {
    gifterEmail: (state: GiftPurchaseSuccessState): Optional<string> => state.gifter_email,
    gifteeEmail: (state: GiftPurchaseSuccessState): Optional<string> => state.giftee_email,
    deliveryDateIsFuture: (state: GiftPurchaseSuccessState): Optional<boolean> =>
      state.delivery_date_is_future,
    deliveryDateFormatted: (state: GiftPurchaseSuccessState): Optional<string> =>
      state.delivery_date_formatted,
    subscribedToExtraEmails: (state: GiftPurchaseSuccessState): Optional<boolean> =>
      state.subscribed_to_extra_emails,
    signedUpToday: (state: GiftPurchaseSuccessState): Optional<boolean> => state.signed_up_today,
  },
};

export default giftPurchaseSuccess;
